// extracted by mini-css-extract-plugin
export default {"container":"PaymentSuccess_container__nvmpk","heading":"PaymentSuccess_heading__X-y5T","message":"PaymentSuccess_message__bQBKW"};